export default "__VITE_ASSET__nVQ$xJbc__"